import { Sparkles } from 'lucide-react';

interface IconProps {
  className?: string;
  size?: number;
  strokeWidth?: number;
}

export function SparklesIcon({ className = '', size = 24, strokeWidth = 1.5 }: IconProps) {
  return (
    <Sparkles
      width={size}
      height={size}
      strokeWidth={strokeWidth}
      className={className}
    />
  );
}
